import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=1e4f46fa&"
import script from "./CustomerProfile.vue?vue&type=script&lang=js&"
export * from "./CustomerProfile.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfile.vue?vue&type=style&index=0&id=1e4f46fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports